import * as React from 'react';
const SvgMapMarkerOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.042 4.042a6.972 6.972 0 0 1 9.86 9.86l-.95.94q-1.051 1.03-2.728 2.652a1.8 1.8 0 0 1-2.504 0l-2.796-2.72q-.527-.517-.882-.872a6.97 6.97 0 0 1 0-9.86m9.01.85a5.77 5.77 0 1 0-8.16 8.16l1.19 1.175q.984.963 2.473 2.403a.6.6 0 0 0 .834 0l2.719-2.643q.563-.553.944-.935a5.77 5.77 0 0 0 0-8.16m-4.08 1.897a2.403 2.403 0 1 1 0 4.806 2.403 2.403 0 0 1 0-4.806m0 1.2a1.202 1.202 0 1 0 0 2.405 1.202 1.202 0 0 0 0-2.404"
    />
  </svg>
);
export default SvgMapMarkerOutlined;
